import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';
import { FavoriteFolder } from 'dataSources/Typicode/favoriteCatalogs';
import { STATUS_LOADING } from 'common/constants';

const action = (
  state: IState,
  payloadAction: PayloadAction<FavoriteFolder & { stationCodes: string[] }>,
) => {
  const { id, name, stationCodes } = payloadAction.payload;

  state.catalogs.data = {
    ...state.catalogs.data,
    [id]: {
      id,
      name,
      statusLoading: STATUS_LOADING.done,
      stationCodes,
      folderId: id,
    },
  };
};

export default action;
